const mutations = {
	SET_NEWS(state, val) {
		state.news= val
	}
}
export default mutations


// WEBPACK FOOTER //
// ./src/store/modules/mutations.js